import { render, staticRenderFns } from "./coderOutpatientFindings.vue?vue&type=template&id=0a45b42e&scoped=true&"
import script from "./coderOutpatientFindings.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientFindings.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientFindings.vue?vue&type=style&index=0&id=0a45b42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45b42e",
  null
  
)

export default component.exports